<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">

    <span class="panel-title" *ngIf="!surveyId">Create {{'Survey' | translate}}</span>
    <span class="panel-title" *ngIf="surveyId">Edit {{'Survey' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>
      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate (ngSubmit)="save(f)">
        <div class="row padding-sm-vr">
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (startDatePicker.dirty || startDatePicker.touched || f.submitted)  && startDatePicker.valid, 'has-error' : (startDatePicker.dirty || startDatePicker.touched || f.submitted)  && startDatePicker.invalid}">
              <label class="control-label">{{'Start Date' | translate}} </label>
              <div class="input-group date">
                <input class="form-control" placeholder="yyyy-mm-dd" required
                       name="startDatePicker" #startDatePicker="ngModel" [disabled]="surveyId"
                       [(ngModel)]="startDate" ngbDatepicker #stYMD="ngbDatepicker">

                <span class="input-group-btn date-label">
                  <button class="btn date-btn" (click)="stYMD.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                </span>


              </div>
              <div *ngIf="(startDatePicker.dirty || startDatePicker.touched || f.submitted)  && startDatePicker.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (endDatePicker.dirty || endDatePicker.touched || f.submitted)  && endDatePicker.valid, 'has-error' : (endDatePicker.dirty || endDatePicker.touched || f.submitted)  && endDatePicker.invalid}">
              <label class="control-label">{{'items.endDate' | translate}} </label>
              <div class="input-group date">
                <input class="form-control" placeholder="yyyy-mm-dd" required
                       name="endDatePicker" #endDatePicker="ngModel"
                       [(ngModel)]="endDate" ngbDatepicker #dpYMD="ngbDatepicker">

                <span class="input-group-btn date-label">
                  <button class="btn date-btn" (click)="dpYMD.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                </span>


              </div>
              <div *ngIf="(endDatePicker.dirty || endDatePicker.touched || f.submitted)  && endDatePicker.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (branchName.dirty || branchName.touched || f.submitted)  && branchName.valid, 'has-error' : (branchName.dirty || branchName.touched || f.submitted)  && branchName.invalid}">
              <label class="control-label">{{'Title' | translate}} </label>
              <input class="form-control" placeholder="{{'Title' | translate}}" required
                     name="branchName" #branchName="ngModel" [disabled]="surveyId"
                     [(ngModel)]="survey.title" type="text" />
              <div *ngIf="(branchName.dirty || branchName.touched || f.submitted)  && branchName.errors?.required" class="jquery-validate-error help-block">
                {{'generalValidations.requiredField' | translate}}
              </div>
            </div>
          </div>


          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (ty.dirty || ty.touched || f.submitted)  && ty.valid, 'has-error' : (ty.dirty || ty.touched || f.submitted)  && ty.invalid}">
              <label class="control-label">{{'Type' |translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="types" [disabled]="surveyId"
                            styleClass="wid100"
                            [placeholder]="'Type'"
                            emptyFilterMessage="{{'app.noItemsFound' |translate}}"
                            showClear="true"
                            name="ty"
                            #ty="ngModel"
                            [(ngModel)]="survey.typeData"
                            baseZIndex="9999"
                            [filter]="true" optionLabel="name"
                            (onChange)="onChangeType()"
                            required>
                </p-dropdown>
              </span>
              <div *ngIf="(ty.dirty || ty.touched || f.submitted)  && ty.invalid" class="jquery-validate-error help-block">
                {{'Type is required' | translate}}
              </div>
            </div>
          </div>

          <div class="col-sm-6" *ngIf="businessUnits&&businessUnits.length>0">
            <div [ngClass]="{'has-success': (bu.dirty || bu.touched || f.submitted)  && bu.valid, 'has-error' : (bu.dirty || bu.touched || f.submitted)  && bu.invalid}">
              <label class="control-label">{{'Business Units' |translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="businessUnits" [disabled]="surveyId"
                            styleClass="wid100"
                            [placeholder]="'Business Units'"
                            emptyFilterMessage="{{'app.noItemsFound' |translate}}"
                            showClear="true"
                            name="bu"
                            #bu="ngModel"
                            [(ngModel)]="survey.businessUnit"
                            baseZIndex="9999"
                            [filter]="true" optionLabel="name"
                            (onChange)="onChangeBU()"
                            required>
                </p-dropdown>
              </span>
              <div *ngIf="(bu.dirty || bu.touched || f.submitted)  && bu.invalid" class="jquery-validate-error help-block">
                {{'Type is required' | translate}}
              </div>
            </div>

          </div>

          <div class="col-sm-6">

            <div class="pull-left">
              <div class="checkbox user-enabled">
                <label>
                  <input type="checkbox" name="isEnabled" [(ngModel)]="survey.isPerBrandSurvey" [disabled]="surveyId">
                  {{'Per Brands' | translate}}
                </label>
              </div>

            </div>


          </div>

        </div>
        <div class="row padding-sm-vr" *ngIf="!survey.isPerBrandSurvey">
          <div class="col-sm-12">

            <div class="row padding-xs-vr" *ngIf="!surveyId">

              <div class="col-sm-6"></div>
              <div class="col-sm-4 left-8"></div>
              <div class="col-sm-2 margin-top-10 cursor-pointer left-6" (click)="addQuestion()">
                <span class="margin-right-7 create-new-span">Add Question</span>
                <i class="fa fa-plus-circle"></i>
              </div>

            </div>
            <div class="panel-group" id="accordion-example">
              <div class="panel" *ngFor="let question of survey.questions; let i = index" [attr.data-index]="i">
                <div class="panel-heading">
                  <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion-example" href="#qu{{i}}">
                    QU #{{i+1}}
                  </a>
                </div> <!-- / .panel-heading -->
                <div id="qu{{i}}" class="panel-collapse collapse">
                  <div class="panel-body">
                    <div class="row padding-xs-vr">

                      <div class="col-sm-6">
                        <div [ngClass]="{'has-success': (questionTit.dirty || questionTit.touched || f.submitted)  && questionTit.valid, 'has-error' : (questionTit.dirty || questionTit.touched || f.submitted)  && questionTit.invalid}">
                          <label class="control-label">{{'Question Title' | translate}} </label>
                          <input class="form-control" placeholder="{{'Question Title' | translate}}"
                                 name="questionTit{{i}}" #questionTit="ngModel" [disabled]="surveyId"
                                 [(ngModel)]="question.title" type="text">

                          <div *ngIf="(questionTit.dirty || questionTit.touched || f.submitted)  && questionTit.invalid" class="jquery-validate-error help-block">
                            {{'repActivities.validations.sharedPercentageRequired' | translate}}
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">

                        <div class="pull-left" *ngIf="!surveyId">
                          <div class="checkbox user-enabled">
                            <label>
                              <input type="checkbox" name="isEnabled{{i}}" [(ngModel)]="question.hasAnswers" [disabled]="surveyId">
                              {{'Has Answer' | translate}}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-2 margin-top-10 cursor-pointer left-6" (click)="deleteQuestion(question)" *ngIf="!surveyId">
                        <span class="margin-right-7 create-new-span">Delete Question</span>
                        <i class="fa fa-trash-o"></i>
                      </div>
                    </div>
                    <div class="row padding-xs-vr">
                      <div class="col-sm-6" *ngIf="!question.hasAnswers">
                        <div [ngClass]="{'has-success': (sco.dirty || sco.touched || f.submitted)  && sco.valid, 'has-error' : (sco.dirty || sco.touched || f.submitted)  && sco.invalid}">
                          <label class="control-label">{{'Score' | translate}} </label>
                          <input class="form-control" placeholder="{{'Score' | translate}}" required
                                 name="sco{{i}}" #sco="ngModel" [disabled]="surveyId"
                                 [(ngModel)]="question.score" type="number">

                          <div *ngIf="(sco.dirty || sco.touched || f.submitted)  && sco.invalid" class="jquery-validate-error help-block">
                            {{'repActivities.validations.sharedPercentageRequired' | translate}}
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4 cursor-pointer" (click)="addAnswer(question)" *ngIf="!surveyId&&question.hasAnswers">
                        <span class="margin-right-7 create-new-span ">Add Answer</span>
                        <i class="fa fa-plus-circle"></i>
                      </div>
                      <div class="col-sm-8"></div>


                    </div>
                    <div *ngIf="question.hasAnswers">
                      <div class="row padding-xs-vr" *ngFor="let answer of question.answers; let t = index" [attr.data-index]="t">
                        <div class="col-sm-4">
                          <div [ngClass]="{'has-success': (an.dirty || an.touched || f.submitted)  && an.valid, 'has-error' : (an.dirty || an.touched || f.submitted)  && an.invalid}">
                            <label class="control-label">{{'Answer' | translate}} </label>
                            <input class="form-control" placeholder="{{'Answer' | translate}}" required
                                   name="an{{i}}{{t}}" #an="ngModel" [disabled]="surveyId"
                                   [(ngModel)]="answer.title" type="text">

                            <div *ngIf="(an.dirty || an.touched || f.submitted)  && an.invalid" class="jquery-validate-error help-block">
                              {{'repActivities.validations.sharedPercentageRequired' | translate}}
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div [ngClass]="{'has-success': (sca.dirty || sca.touched || f.submitted)  && sca.valid, 'has-error' : (sca.dirty || sca.touched || f.submitted)  && sca.invalid}">
                            <label class="control-label">{{'Score' | translate}} </label>
                            <input class="form-control" placeholder="{{'Score' | translate}}" required
                                   name="sca{{i}}{{t}}" #sca="ngModel" [disabled]="surveyId"
                                   [(ngModel)]="answer.score" type="number">

                            <div *ngIf="(sca.dirty || sca.touched || f.submitted)  && sca.invalid" class="jquery-validate-error help-block">
                              {{'repActivities.validations.sharedPercentageRequired' | translate}}
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-2 margin-top-10 cursor-pointer left-6" (click)="deleteAnswer(question,answer)" *ngIf="!surveyId">
                          <span class="margin-right-7 create-new-span">Delete Answer</span>
                          <i class="fa fa-trash-o"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row padding-sm-vr" *ngIf="survey.isPerBrandSurvey">
          <div class="col-sm-12">
            <div class="panel-group" id="accordion-example_1">
              <div class="panel" *ngFor="let brand of itemBrands; let y = index" [attr.data-index]="y">
                <div class="panel-heading">
                  <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion-example" href="#b{{y}}">
                    {{brand.name}}
                  </a>
                </div>
                <div id="b{{y}}" class="panel-collapse collapse">
                  <div class="panel-body">

                    <div class="row padding-xs-vr" *ngIf="!surveyId">

                      <div class="col-sm-6"></div>
                      <div class="col-sm-4 left-8"></div>
                      <div class="col-sm-2 margin-top-10 cursor-pointer left-6" (click)="addQuestionBrand(brand)">
                        <span class="margin-right-7 create-new-span">Add Question</span>
                        <i class="fa fa-plus-circle"></i>
                      </div>

                    </div>
                    <div class="panel-group" id="accordion-example_2">
                      <div class="panel" *ngFor="let question of brand.questions; let i = index" [attr.data-index]="i">
                        <div class="panel-heading">
                          <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion-example" href="#qub{{y}}{{i}}">
                            QU #{{i+1}}
                          </a>
                        </div> <!-- / .panel-heading -->
                        <div id="qub{{y}}{{i}}" class="panel-collapse collapse">
                          <div class="panel-body">
                            <div class="row padding-xs-vr">

                              <div class="col-sm-6">
                                <div [ngClass]="{'has-success': (questionTit.dirty || questionTit.touched || f.submitted)  && questionTit.valid, 'has-error' : (questionTit.dirty || questionTit.touched || f.submitted)  && questionTit.invalid}">
                                  <label class="control-label">{{'Question Title' | translate}} </label>
                                  <input class="form-control" placeholder="{{'Question Title' | translate}}"
                                         name="questionTit{{y}}{{i}}" #questionTit="ngModel" [disabled]="surveyId"
                                         [(ngModel)]="question.title" type="text">

                                  <div *ngIf="(questionTit.dirty || questionTit.touched || f.submitted)  && questionTit.invalid" class="jquery-validate-error help-block">
                                    {{'repActivities.validations.sharedPercentageRequired' | translate}}
                                  </div>
                                </div>
                              </div>

                              <div class="col-sm-4">

                                <div class="pull-left" *ngIf="!surveyId">
                                  <div class="checkbox user-enabled">
                                    <label>
                                      <input type="checkbox" name="isEnabled{{y}}{{i}}" [(ngModel)]="question.hasAnswers" [disabled]="surveyId">
                                      {{'Has Answer' | translate}}
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div class="col-sm-2 margin-top-10 cursor-pointer left-6" (click)="deleteQuestionBrand(brand,question)" *ngIf="!surveyId">
                                <span class="margin-right-7 create-new-span">Delete Question</span>
                                <i class="fa fa-trash-o"></i>
                              </div>
                            </div>





                            <div class="row padding-xs-vr">
                              <div class="col-sm-6" *ngIf="!question.hasAnswers">
                                <div [ngClass]="{'has-success': (sco.dirty || sco.touched || f.submitted)  && sco.valid, 'has-error' : (sco.dirty || sco.touched || f.submitted)  && sco.invalid}">
                                  <label class="control-label">{{'Score' | translate}} </label>
                                  <input class="form-control" placeholder="{{'Score' | translate}}" required
                                         name="sco{{y}}{{i}}" #sco="ngModel" [disabled]="surveyId"
                                         [(ngModel)]="question.score" type="number">

                                  <div *ngIf="(sco.dirty || sco.touched || f.submitted)  && sco.invalid" class="jquery-validate-error help-block">
                                    {{'repActivities.validations.sharedPercentageRequired' | translate}}
                                  </div>
                                </div>
                              </div>
                              <div class="col-sm-4 cursor-pointer" (click)="addAnswer(question)" *ngIf="!surveyId&&question.hasAnswers">
                                <span class="margin-right-7 create-new-span ">Add Answer</span>
                                <i class="fa fa-plus-circle"></i>
                              </div>
                              <div class="col-sm-8"></div>


                            </div>
                            <div *ngIf="question.hasAnswers">
                              <div class="row padding-xs-vr" *ngFor="let answer of question.answers; let t = index" [attr.data-index]="t">
                                <div class="col-sm-4">
                                  <div [ngClass]="{'has-success': (an.dirty || an.touched || f.submitted)  && an.valid, 'has-error' : (an.dirty || an.touched || f.submitted)  && an.invalid}">
                                    <label class="control-label">{{'Answer' | translate}} </label>
                                    <input class="form-control" placeholder="{{'Answer' | translate}}" required
                                           name="an{{y}}{{i}}{{t}}" #an="ngModel" [disabled]="surveyId"
                                           [(ngModel)]="answer.title" type="text">

                                    <div *ngIf="(an.dirty || an.touched || f.submitted)  && an.invalid" class="jquery-validate-error help-block">
                                      {{'repActivities.validations.sharedPercentageRequired' | translate}}
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div [ngClass]="{'has-success': (sca.dirty || sca.touched || f.submitted)  && sca.valid, 'has-error' : (sca.dirty || sca.touched || f.submitted)  && sca.invalid}">
                                    <label class="control-label">{{'Score' | translate}} </label>
                                    <input class="form-control" placeholder="{{'Score' | translate}}" required
                                           name="sca{{y}}{{i}}{{t}}" #sca="ngModel" [disabled]="surveyId"
                                           [(ngModel)]="answer.score" type="number">

                                    <div *ngIf="(sca.dirty || sca.touched || f.submitted)  && sca.invalid" class="jquery-validate-error help-block">
                                      {{'repActivities.validations.sharedPercentageRequired' | translate}}
                                    </div>
                                  </div>
                                </div>


                                <div class="col-sm-2 margin-top-10 cursor-pointer left-6" (click)="deleteAnswer(question,answer)" *ngIf="!surveyId">
                                  <span class="margin-right-7 create-new-span">Delete Answer</span>
                                  <i class="fa fa-trash-o"></i>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12">


          </div>
        </div>

        <div class="row padding-sm-vr">
          <div class="col-sm-12">

            <div class="row padding-xs-vr" *ngIf="!surveyId">

              <div class="col-sm-6"></div>
              <div class="col-sm-4 left-8"></div>
              <div class="col-sm-2 margin-top-10 cursor-pointer left-6" (click)="addScore()">
                <span class="margin-right-7 create-new-span">Add Score</span>
                <i class="fa fa-plus-circle"></i>
              </div>

            </div>
            <div class="panel-group" id="accordion-example">
              <div class="panel" *ngFor="let score of survey.scores; let i = index" [attr.data-index]="i">
                <div class="panel-heading">
                  <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion-example" href="#sc{{i}}">
                    Score #{{i+1}}
                  </a>
                </div> <!-- / .panel-heading -->
                <div id="sc{{i}}" class="panel-collapse collapse">
                  <div class="panel-body">
                    <div class="row padding-xs-vr">
                      <div class="col-sm-3">
                        <div [ngClass]="{'has-success': (clas.dirty || clas.touched || f.submitted)  && clas.valid, 'has-error' : (clas.dirty || clas.touched || f.submitted)  && clas.invalid}">
                          <label class="control-label">{{'Class' |translate}} </label>
                          <span class="ui-fluid">
                            <p-dropdown [options]="filteredClasses" [disabled]="surveyId"
                                        styleClass="wid100"
                                        [placeholder]="'Class'"
                                        emptyFilterMessage="{{'app.noItemsFound' |translate}}"
                                        showClear="true"
                                        name="clas{{i}}"
                                        #clas="ngModel"
                                        [(ngModel)]="score.class"
                                        baseZIndex="9999"
                                        [filter]="true" optionLabel="name"
                                        required>
                            </p-dropdown>
                          </span>
                          <div *ngIf="(clas.dirty || clas.touched || f.submitted)  && clas.invalid" class="jquery-validate-error help-block">
                            {{'Class is required' | translate}}
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div [ngClass]="{'has-success': (fro.dirty || fro.touched || f.submitted)  && fro.valid, 'has-error' : (fro.dirty || fro.touched || f.submitted)  && fro.invalid}">
                          <label class="control-label">{{'Score From' | translate}} </label>
                          <input class="form-control" placeholder="{{'Score From' | translate}}"
                                 name="fro{{i}}" #fro="ngModel" [disabled]="surveyId"
                                 [(ngModel)]="score.scoreFrom" type="number">

                          <div *ngIf="(fro.dirty || fro.touched || f.submitted)  && fro.invalid" class="jquery-validate-error help-block">
                            {{'repActivities.validations.sharedPercentageRequired' | translate}}
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div [ngClass]="{'has-success': (to.dirty || to.touched || f.submitted)  && to.valid, 'has-error' : (to.dirty || to.touched || f.submitted)  && to.invalid}">
                          <label class="control-label">{{'Score To' | translate}} </label>
                          <input class="form-control" placeholder="{{'Score To' | translate}}"
                                 name="to{{i}}" #to="ngModel" [disabled]="surveyId"
                                 [(ngModel)]="score.scoreTo" type="number">

                          <div *ngIf="(to.dirty || to.touched || f.submitted)  && to.invalid" class="jquery-validate-error help-block">
                            {{'repActivities.validations.sharedPercentageRequired' | translate}}
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-2 margin-top-10 cursor-pointer left-6" (click)="deleteScore(score)" *ngIf="!surveyId">
                        <span class="margin-right-7 create-new-span">Delete Score</span>
                        <i class="fa fa-trash-o"></i>
                      </div>
                    </div>

                    <!--<div class="row padding-xs-vr">
                      <div class="col-sm-6"></div>
                      <div class="col-sm-4 left-8"></div>
                      <div class="col-sm-2 margin-top-10 cursor-pointer left-6" (click)="deleteQuestion(question)">
                        <span class="margin-right-7 create-new-span">Delete Question</span>
                        <i class="fa fa-trash-o"></i>
                      </div>

                    </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit" [disabled]="f.invalid">{{'app.save' | translate}}</button>

        </div>

      </form>
    </div>
  </div>
</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>




